import React from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import PageBanner from "@/components/PageBanner";
import SectionTitle from "@/components/SectionTitle";
import FinalCTA from "@/components/FinalCTA";
import { CLIENTS, IMAGES } from "@/lib/content";
import { Globe, HeartHandshake, Ship, Building2, HardHat, Landmark } from "lucide-react";

const ICONS = { Globe, HeartHandshake, Ship, Building2, HardHat, Landmark };

const Clients = () => {
  return (
    <div className="min-h-screen flex flex-col bg-abayle-ivory">
      <Navbar />
      <main>
        <PageBanner
          eyebrow="Our Clients"
          title="Clients We Serve"
          subtitle="Supporting institutional, commercial, and project based clients across Somalia."
          image={IMAGES.clients}
        />

        <section className="bg-white" data-testid="clients-intro">
          <div className="container-abayle py-14 sm:py-20 lg:py-24 text-center max-w-3xl mx-auto">
            <SectionTitle
              centered
              eyebrow="Who We Serve"
              title="Coordinated Support for Serious Operations"
              subtitle="Abayle serves clients that need dependable service, coordinated support, and practical solutions across trade, movement, transport, and business operations."
            />
          </div>
        </section>

        <section className="bg-abayle-ivory" data-testid="clients-grid">
          <div className="container-abayle pb-20 lg:pb-28">
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {CLIENTS.map((c, idx) => {
                const Icon = ICONS[c.icon];
                return (
                  <div key={c.title} className="card-abayle group" data-testid={`client-${idx}`}>
                    <div className="flex items-start gap-5">
                      <div className="shrink-0 h-14 w-14 rounded-md bg-abayle-green/5 border border-abayle-green/20 flex items-center justify-center group-hover:bg-abayle-green group-hover:border-abayle-green transition-all">
                        <Icon className="h-6 w-6 text-abayle-green group-hover:text-white transition-colors" />
                      </div>
                      <div>
                        <div className="text-abayle-gold text-xs font-bold tracking-[0.2em] uppercase mb-1">0{idx + 1}</div>
                        <h3 className="text-abayle-green font-bold text-lg mb-2 leading-snug">{c.title}</h3>
                        <p className="text-abayle-charcoal/75 text-[15px] leading-relaxed">{c.text}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
};

export default Clients;
